<template>
    <painel-component :itens="itensOne">

        <row-component>
            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>Nome:</label>
                <input-component :type-input="'text'" v-model="formData.name"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>Status:</label>
                <Multiselect v-model="formData.status" :options="selectActiveInative" :searchable="true"
                             :noOptionsText="noOptionsText"
                             :noResultsText="noResultsText"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>CNPJ:</label>
                <input-component v-mask="'##.###.###/####-##'" :type-input="'text'" v-model="formData.cnpj"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-12'">
                <label>CPF:</label>
                <input-component v-mask="'###.###.###-##'" :type-input="'text'" v-model="formData.cpf"/>
            </row-col-component>

            <row-col-component :class-row-col="'col-xxl-2 col-xl-2 col-lg-2 col-md-12 col-sm-12 col-12'">
                <button-submit @submit="submit" :items="buttonSubmit" class="me-2"/>
                <button-route v-if="buttonCheck.create" :items="buttonRoute"/>
            </row-col-component>
        </row-component>

        <table class="table table-striped">
            <thead>
            <tr>
                <th scope="col" style="width: 30%">Nome</th>
                <th scope="col" style="width: 20%">Status</th>
                <th scope="col" style="width: 30%">CPF / CNPJ</th>
                <th scope="col" style="width: 10%" v-if="buttonCheck.show || buttonCheck.edit || buttonCheck.delete">
                    Ações
                </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(client, index) in client.data" :key="index">
                <td data-label="Nome">
                    <img v-if="client.photo" class="avatar__image mx-1" :src="client.photo" alt="">
                    <img v-else class="avatar__image mx-1" src="@/assets/images/avatar.png" alt="">
                    {{ client.surname }}
                </td>
                <td data-label="Status">{{ statusString(client.status) }}</td>
                <td data-label="CPF / CNPJ">{{ client.cpf }} {{ client.cnpj }}</td>
                <td data-label="Ações">
                    <button-edit v-if="buttonCheck.edit" :route="'client-edit'" :id-param="client.id"/>
                    <button-delete v-if="buttonCheck.delete" @click="destroyClient(client)"/>
                    <button-show v-if="buttonCheck.show" :route="'client-show'" :id-param="client.id"/>
                </td>
            </tr>
            </tbody>
        </table>

        <button-pagination :pagination="client" :offset="3" @paginate="loadClients"/>

    </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import RowColComponent from '@/components/row/RowColComponent';
import InputComponent from '@/components/form/InputComponent';
import Multiselect from '@vueform/multiselect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonEdit from '@/components/buttons/ButtonEdit';
import ButtonShow from '@/components/buttons/ButtonShow';
import {useToast} from "vue-toastification";
import {mask} from 'vue-the-mask'
import ButtonPagination from "@/components/buttons/ButtonPagination.vue";
import ButtonDelete from "@/components/buttons/ButtonDelete.vue";
import swal from "sweetalert";

const toast = useToast()

export default {
    name: 'ClientSearch',

    created() {
        this.$store.dispatch('updateNamePage', 'Cliente')
        this.checkACL()
        this.loadClients(1)
    },

    components: {
        ButtonDelete,
        ButtonPagination,
        PainelComponent,
        RowComponent,
        RowColComponent,
        InputComponent,
        Multiselect,
        ButtonSubmit,
        ButtonRoute,
        ButtonEdit,
        ButtonShow
    },

    directives: {
        mask
    },

    data() {
        return {
            itensOne: {
                title: "Pesquisa",
                icon: "ti-list"
            },

            buttonSubmit: {
                icon: 'ti-search',
            },

            buttonRoute: {
                icon: 'ti-plus',
                route: '/client/create'
            },

            buttonCheck: {
                edit: false,
                create: false,
                show: false,
                delete: false
            },

            formData: {
                name: '',
                cnpj: '',
                cpf: '',
                status: ''
            },

            searchSubmit: false,
        }
    },

    methods: {

        submit() {
            this.loadClients(1)
            this.searchSubmit = true
        },

        statusString(value) {
            if (value === '1')
                return 'Ativo'
            return 'Inativo'
        },

        loadClients(page) {
            if (!this.searchSubmit) {
                this.$store.dispatch('loadClients', {...this.params, page})
                    .then((r) => {
                        if (this.searchSubmit) {
                            this.searchSubmit = false;
                            if (r.data == '') {
                                toast.info("Nada foi encontrado com os parâmetros informados!", {timeout: 2000});
                            }
                        }
                    }).catch(() => {
                    this.searchSubmit = false;
                });
            }
        },

        destroyClient(item) {
            swal({
                title: 'Atenção!',
                text: `Deseja realmente deletar ${item.name}, ${this.me.name} ?`,
                closeOnClickOutside: false,
                buttons: {
                    cancel: {
                        text: 'Não',
                        visible: true,
                        closeModal: true,
                    },
                    confirm: "Sim"
                }
            }).then((result) => {
                if (result) {
                    this.$store.dispatch('destroyClient', item.id).then(() => {
                        this.loadUsers(1)
                        toast.success('Cadastro deletado com sucesso', {timeout: 2000});
                    }).catch((e) => {
                        let error = e.response.data.errors
                        if (error.length > 0)
                            toast.error(`Não foi possível excluir, o item está em uso!`, {timeout: 2000});
                        else
                            toast.error(`Não foi possível deletar  ${item.name} `, {timeout: 2000});
                    })
                }
            });
        },

        async checkACL() {
            this.$store.dispatch('ACLitens', 3)
                .then((r) => {
                    if (r.data.indexOf('client-search') !== -1) {

                        if (r.data.indexOf('client-search') !== -1) {
                            this.buttonCheck.show = true
                        }

                        if (r.data.indexOf('client-create') !== -1) {
                            this.buttonCheck.create = true
                        }

                        if (r.data.indexOf('client-edit') !== -1) {
                            this.buttonCheck.edit = true
                        }

                        if (r.data.indexOf('client-delete') !== -1) {
                            this.buttonCheck.delete = true
                        }
                    } else {
                        this.$router.push({name: 'home'})
                    }
                }).catch(() => {
                this.$router.push({name: 'home'})
            })
        },

    },

    computed: {
        selectActiveInative() {
            return this.$store.state.var.selectActiveInative
        },

        noResultsText() {
            return this.$store.state.var.noResultsText
        },

        noOptionsText() {
            return this.$store.state.var.noOptionsText
        },

        client() {
            return this.$store.state.client.items
        },

        params() {
            return {
                page: this.client.current_page,
                name: this.formData.name,
                cnpj: this.formData.cnpj,
                cpf: this.formData.cpf,
                status: this.formData.status
            }
        },

        me() {
            return this.$store.state.auth.me
        },
    }

}
</script>

<style src="@/assets/style/table.css">

</style>

<style scoped>
.avatar__image {
    width: 40px;
}
</style>
